import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import Img from 'gatsby-image';

const Project = styled(Link)`
  width: 100%;
  pointer-events: auto;
  text-align: center;
  padding-bottom: 0;
  &:hover {
    text-decoration: none;
  }
  h5 {
    ${props => props.theme.main.fonts.heading}
    margin-bottom: 3px;
  }
  p {
    ${props => props.theme.main.fonts.body}
  }
  ${breakpoint('md')`
    text-align: left;
  `}
`;

const StyledImg = styled(Img)`
  max-width: calc(0.8*535px);
  width: 100%;
  max-height: calc(0.8*732px);
  margin: 10px auto;
`;


export default ({project}) => {
  return (
    <Project to={`/projects/${project.slug}`}>
      <StyledImg alt={project.heading} fluid={project.projectPageThumbnail.fluid} />
      <h5>{project.heading}</h5>
      <p>{project.subHeading}</p>
    </Project>);
}